import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["slides", "loop"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo, useRef } from 'react';
export var useAutoplayProps = function useAutoplayProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    enabled = _ref.enabled,
    interval = _ref.interval;
  return useMemo(function () {
    return {
      enabled: enabled !== null && enabled !== void 0 ? enabled : false,
      interval: interval !== null && interval !== void 0 ? interval : 5000
    };
  }, [enabled, interval]);
};
export var useNavigationProps = function useNavigationProps() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    size = _ref2.size,
    position = _ref2.position,
    enableKeyboard = _ref2.enableKeyboard,
    showArrows = _ref2.showArrows;
  return useMemo(function () {
    return {
      enableKeyboard: enableKeyboard !== null && enableKeyboard !== void 0 ? enableKeyboard : true,
      position: position !== null && position !== void 0 ? position : 'inside',
      showArrows: showArrows !== null && showArrows !== void 0 ? showArrows : true,
      size: size !== null && size !== void 0 ? size : 'medium'
    };
  }, [enableKeyboard, position, showArrows, size]);
};
export var usePaginationProps = function usePaginationProps() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    show = _ref3.show,
    style = _ref3.style;
  return useMemo(function () {
    return {
      show: show !== null && show !== void 0 ? show : true,
      style: style !== null && style !== void 0 ? style : 'dots'
    };
  }, [show, style]);
};
export var useSliderProps = function useSliderProps() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    slides = _ref4.slides,
    loop = _ref4.loop,
    rest = _objectWithoutProperties(_ref4, _excluded);
  var loopRef = useRef(loop);
  var restRef = useRef(rest);
  var slidesRef = useRef(slides);
  return useMemo(function () {
    var _loopRef$current;
    return _objectSpread({
      loop: (_loopRef$current = loopRef.current) !== null && _loopRef$current !== void 0 ? _loopRef$current : true,
      slides: _typeof(slidesRef.current) === 'object' ? _objectSpread({
        perView: 1
      }, slidesRef.current) : slidesRef.current
    }, restRef.current);
  }, []);
};
//# sourceMappingURL=hooks.js.map